import urlUtil from 'scripts/utils/url';
import _ from 'lodash';
import { PROBABILITY_PAGE_TYPE } from 'components/probability/tooltip-handler';
import sessionStorage from 'scripts/services/sessionstorage-service';

function getSatellite() {
    return window._satellite;
}

const satelliteDecorator = (handler) => (...params) => {
    const satellite = getSatellite();

    if (satellite == null) {
        return;
    }

    _.partial(handler, satellite)(...params);
};

export default {
    setPageData(pageName) {
        if (getSatellite() != null) {
            setPageDigitalData(pageName);
        }
    },
    setPageDataVC(pageName) {
        if (getSatellite() != null) {
            setPageDigitalDataVC(pageName);
        }
    },
    execFooterScript() {
        if (typeof getSatellite() !== 'undefined') {
            getSatellite().pageBottom();
            console.debug('pageBottom launched');
        }
    },
    getPageName() {
        return _.get(window, 'digitalData.page.pageInfo.PageName', 'U.S. Open');
    },
    trackKbygOpen(moduleName) {
        if (getSatellite() != null) {
            setKbygDigitalData(moduleName);
            getSatellite().track('kbyg');
        }
    },
    trackTrendingBoxLoad() {
        if (getSatellite() != null) {
            setTrandingDigitalData();
            getSatellite().track('trendingBoxLoads');
        }
    },
    trackAmexLoad() {
        if (getSatellite() != null) {
            setAmexDigitalData();
            getSatellite().track('amexLoads');
        }
    },
    trackRoadToUsoDigitalData(playerName) {
        if (getSatellite() != null) {
            setRoadToUsoDigitalData(playerName);
            getSatellite().track('road-to-uso');
        }
    },
    trackVideoLaunch(videoName, videoSourceLocation) {
        if (getSatellite() != null) {
            setVideoLaunchDigitalData(videoName, videoSourceLocation);
            getSatellite().track('video-launch');
        }
    },
    trackLiveAudioLaunch(videoName, videoSourceLocation) {
        if (getSatellite() != null) {
            setVideoLaunchDigitalData(videoName, videoSourceLocation);
            getSatellite().track('live-audio-click');
        }
    },
    trackLiveVideoLaunch(videoName, videoSourceLocation) {
        if (getSatellite() != null) {
            setVideoLaunchDigitalData(videoName, videoSourceLocation);
            getSatellite().track('live-video-click');
        }
    },
    trackLiveVideoViewChange(selectedMultiviewLiveView) {
        if (getSatellite() != null) {
            setLiveVideoViewDigitalData(selectedMultiviewLiveView);
            getSatellite().track('live-video-selects-multiview-option');
        }
    },
    trackVideoFilter(filterName) {
        if (getSatellite() !== null) {
            setVideoFilterDigitalData(filterName);
            getSatellite().track('vod-filter');
        }
    },
    trackScatterPlot(element) {
        if (getSatellite() != null) {
            setScatterPlotDigitalData(element);
            getSatellite().track('scatter-plot');
        }
    },
    trackShots(playerId) {
        if (getSatellite() != null) {
            setShotsDigitalData(playerId);
            getSatellite().track('shot-by-shot');
        }
    },
    trackTeeTimesTab(tab, tabData) {
        if (getSatellite() != null) {
            setTabDigitalData(tab, tabData);
            getSatellite().track('tee-times-tab');
        }
    },
    trackPlayerStatsTab(tab, tabData, round) {
        if (getSatellite() != null) {
            setTabDigitalData(tab, tabData);
            setPlayerStatsRound(round);
            getSatellite().track('player-stats-tab');
        }
    },
    trackRoundTrackerClick(round) {
        if (getSatellite() != null) {
            setRoundTracker(round);
            getSatellite().track('round-tracker-click');
        }
    },
    trackPlayerDetailTab(tab, tabData) {
        if (getSatellite() != null) {
            setTabDigitalData(tab, tabData);
            getSatellite().track('player-detail-tab');
        }
    },
    trackInternationalBroadcast() {
        if (getSatellite() != null) {
            getSatellite().track('ibf-search');
        }
    },
    trackLeaderboardFavoriting(playerName) {
        if (getSatellite() != null) {
            setLeaderboardFavoritingDigitalData(playerName);
            getSatellite().track('favoriting-player');
        }
    },
    trackLeaderboardExpand(playerName) {
        if (getSatellite() != null) {
            setLeaderboardExpandDigitalData(playerName);
            getSatellite().track('lbd-expand');
        }
    },
    trackPollSubmission() {
        if (getSatellite() != null) {
            getSatellite().track('poll-submission');
        }
    },
    trackTeeTimesCalendar() {
        if (getSatellite() != null) {
            getSatellite().track('calendar-icon');
        }
    },
    trackPipChannelSwap() {
        if (getSatellite() != null) {
            getSatellite().track('pip-channel-swap');
        }
    },
    trackPipGoFullScreen() {
        if (getSatellite() != null) {
            getSatellite().track('go-full-screen');
        }
    },
    trackPipInteraction() {
        if (getSatellite() != null) {
            getSatellite().track('pip-interaction');
        }
    },
    trackHistoryTimelineCollectionCtaClick(tagName) {
        if (getSatellite() != null) {
            setTistoryTimelineCollectionTag(tagName);
            getSatellite().track('history-timeline-collection-cta-click');
        }
    },
    trackHistoryTimelineCollectionSelection(tagName) {
        if (getSatellite() != null) {
            setTistoryTimelineCollectionTag(tagName);
            getSatellite().track('history-timeline-collection-selection');
        }
    },
    trackHistoryTimelineYearSelection(year) {
        if (getSatellite() != null) {
            setTistoryTimelineYear(year);
            getSatellite().track('history-timeline-tag-selection');
        }
    },
    trackHistoryTimelineTagSelection(tag) {
        if (getSatellite() != null) {
            setTistoryTimelineTag(tag);
            getSatellite().track('history-timeline-tag-selection');
        }
    },
    trackHistoryContentView(cardTitle, cardType, year, tag) {
        if (getSatellite() != null) {
            setHistoryContentView(cardTitle, cardType, year, tag);
            getSatellite().track('history-timeline-content-view');
        }
    },
    trackHistoryVideoLauch(videoName, videoLocation) {
        if (getSatellite() != null) {
            setHistoryTimelineVideoLauch(videoName, videoLocation);
            getSatellite().track('history-video-launch');
        }
    },
    trackClickOnPromoModal() {
        if (getSatellite() != null) {
            getSatellite().track('click-on-promo-modal');
        }
    },
    trackBiggestMoversFullLeaderboardClick() {
        if (getSatellite() != null) {
            getSatellite().track('biggest-movers-full-leaderboard-click');
        }
    },
    trackInfoCardExpand(infoCardTitle) {
        if (getSatellite() != null) {
            setInfoCardTitleExpand(infoCardTitle);
            getSatellite().track('info-card-expand');
        }
    },
    trackSwitchToShotsViewInDrawer() {
        if (getSatellite() != null) {
            getSatellite().track('switch-to-shots-view-in-drawer');
        }
    },
    trackTimelinePhotoGalleryActivity(galleryName) {
        if (getSatellite() != null) {
            setTimelinePhotoGalleryName(galleryName);
            getSatellite().track('timeline-photo-gallery-activity');
        }
    },
    trackTimelineLiveVideoActivity(liveVideoLocation) {
        if (getSatellite() != null) {
            setLiveVideoLocation(liveVideoLocation);
            getSatellite().track('timeline-live-video-activity');
        }
    },
    trackLiveVideoLandingPage() {
        if (getSatellite() != null) {
            getSatellite().track('live-video-landing-page');
        }
    },
    trackSearch(searchTerms) {
        if (getSatellite() != null) {
            setSearchTerms(searchTerms);
            getSatellite().track('search-click');
        }
    },
    trackLatestTimeline(cardIndex, cardType) {
        if (getSatellite() != null) {
            setContentItemData(cardIndex, cardType);
            getSatellite().track('timeline-card-activity');
        }
    },
    trackFeaturedTimeline(galleryName) {
        if (getSatellite() != null) {
            setVCPhotoGalleryName(galleryName);
            getSatellite().track('featured-card-activity');
        }
    },
    trackFeaturedArticle(galleryName) {
        if (getSatellite() != null) {
            setVCArticleName(galleryName);
            getSatellite().track('featured-card-article');
        }
    },
    trackFeaturedVideo(galleryName) {
        if (getSatellite() != null) {
            setVCVideoName(galleryName);
            getSatellite().track('featured-card-video');
        }
    },
    trackSearchByPlayerCourse(name) {
        if (getSatellite() != null) {
            setPlayerCourseName(name);
            getSatellite().track('search-by-player-course');
        }
    },
    trackMixedCard(cardType) {
        if (getSatellite() != null) {
            setMixedCardType(cardType);
            getSatellite().track('mixed-card-click');
        }
    },
    trackLatestContentFilterChange: satelliteDecorator(
        (satellite, filterName) => {
            setLatestContentFilterChange(filterName);
            satellite.track('vc-latest-content-filter-change');
        },
    ),
    trackHeroSlideClick: satelliteDecorator(
        (satellite, title, buttonTitle, slideNumber) => {
            setVCHeroSlideImageTitle(title);
            setVCHeroSlideButtonTitle(buttonTitle);
            setVCHeroSlideNumber(slideNumber);
            getSatellite().track('vc-hero-slide-click');
        },
    ),
    trackLatestPinnedCardClick: satelliteDecorator((satellite, title) => {
        setLatestPinnedCardTitle(title);
        satellite.track('vc-latest-pinned-card-click');
    }),
    trackLatestCardNumberClick: satelliteDecorator((satellite, cardIndex) => {
        setLatestCardIndex(cardIndex);
        satellite.track('vc-latest-card-index');
    }),
    trackWinProbabilityTabClick: satelliteDecorator(
        (satellite, playerName, moduleName, comparisonNames) => {
            setPlayerName(playerName);
            setProbabilityModuleName(moduleName);
            setComparisonPlayerNames(comparisonNames);
            satellite.track('win-probability-tab-clicks');
        },
    ),
    trackWinProbabilityPlayerClick: satelliteDecorator(
        (satellite, playerName, probabilityTracker) => {
            setPlayerName(playerName);
            setProbabilityTracker(_.startCase(probabilityTracker));
            satellite.track('win-probability-player-click');
        },
    ),
    trackWinProbabilityFullFieldClick: satelliteDecorator((satellite) => {
        satellite.track('win-probability-full-field-click');
    }),
    trackWinProbabilityTrackerTabClick: satelliteDecorator(
        (satellite, probabilityTracker) => {
            setProbabilityTracker(_.startCase(probabilityTracker));
            satellite.track('win-probability-tab-clicks');
        },
    ),
    trackLatestWinProbabilityTrackerTabClick: satelliteDecorator(
        (satellite, probabilityTracker) => {
            setProbabilityTracker(_.startCase(probabilityTracker));
            satellite.track('latest-win-probability-tab-click');
        },
    ),
    trackTop10ProbabilityTabClick: satelliteDecorator(
        (satellite, playerName, moduleName, comparisonNames) => {
            setPlayerName(playerName);
            setProbabilityModuleName(moduleName);
            setComparisonPlayerNames(comparisonNames);
            satellite.track('top-10-tab-click');
        },
    ),
    trackMakeCutProbabilityTabClick: satelliteDecorator(
        (satellite, playerName, moduleName, comparisonNames) => {
            setPlayerName(playerName);
            setProbabilityModuleName(moduleName);
            setComparisonPlayerNames(comparisonNames);
            satellite.track('make-cut-tab-click');
        },
    ),
    trackProbabilityChartClick: satelliteDecorator(
        (satellite, playerName, tabName, moduleName, compareName) => {
            setPlayerName(playerName);
            setProbabilityTabName(tabName);
            setProbabilityModuleName(moduleName);
            setComparisonPlayerNames(compareName);
            satellite.track('probability-chart-click');
        },
    ),
    trackLatestProbabilityChartClick: satelliteDecorator(
        (satellite, playerName, probabilityTracker, sourcePage) => {
            setPlayerName(playerName);
            setProbabilityTracker(_.startCase(probabilityTracker));
            setSourcePage(sourcePage);
            satellite.track('latest-probability-chart-click');
        },
    ),
    trackProbabilityChartArrowClick: satelliteDecorator(
        (satellite, playerName, tabName) => {
            setPlayerName(playerName);
            setProbabilityTabName(tabName);
            satellite.track('probability-chart-arrow');
        },
    ),
    trackProbabilityVSToggleChange: satelliteDecorator(
        (satellite, playerName) => {
            setPlayerName(playerName);
            satellite.track('vs-leader-clicks');
        },
    ),
    trackLatestBadgedCardClick: satelliteDecorator(
        (satellite, badge, targetUrl, targetTitle) => {
            setLatestCardBadge(badge);
            setTargetUrl(targetUrl);
            setTargetTitle(targetTitle);
            satellite.track('badged-content-click');
        },
    ),
    trackBiggestMoversClick: satelliteDecorator((satellite, playerName) => {
        setPlayerName(playerName);
        satellite.track('biggest-movers-click');
    }),
    trackAlertButtonClick: satelliteDecorator((satellite, message, type) => {
        setAlertMessage(message);
        setAlertType(type);
        satellite.track('notification-alert-click');
    }),
    trackFullRecapProbabilityChartClick: satelliteDecorator(
        (satellite, playerName, tabName, moduleName) => {
            setPlayerName(playerName);
            setProbabilityTabName(tabName);
            setProbabilityModuleName(moduleName);
            satellite.track('full-recap-probability-chart-click');
        },
    ),
    trackPlayersCompareClick: satelliteDecorator((satellite, playersName) => {
        setComparisonPlayerNames(playersName);
        satellite.track('player-comparison-selections');
    }),
    trackBiggestMoversPlayersCompareClick: satelliteDecorator(
        (satellite, playersName) => {
            setComparisonPlayerNames(playersName);
            setPlayerComparisonLocation('Biggest Movers');
            satellite.track('player-comparison-selections');
        },
    ),
    trackPlayerProfileClick: satelliteDecorator(
        (satellite, playersName, sourcePage) => {
            setPlayerName(playersName);
            setSourcePage(sourcePage);
            satellite.track('player-profile-click');
        },
    ),
    trackChatBotButtonClick: satelliteDecorator((satellite) => {
        satellite.track('chatbot-click');
    }),
    trackMerchandiseUnitClick: satelliteDecorator((satellite, productUrl) => {
        setTargetUrl(productUrl);
        satellite.track('merchandise-product-click');
    }),
    trackPhotoGallerySwipe: satelliteDecorator(
        (satellite, galleryName, photoId, photoCaption, photoNumber) => {
            setTimelinePhotoGalleryName(galleryName);
            setTimelineGalleryPhotoId(photoId);
            setTimelineGalleryPhotoCaption(photoCaption);
            setTimelineGalleryPhotoNumber(photoNumber);
            satellite.track('photo-gallery-swipe');
        },
    ),
    trackMenuItemClick: satelliteDecorator((satellite, name, url) => {
        setMenuItemName(name);
        setMenuItemURL(url);
        satellite.track('menu-item-click');
    }),
    trackWatchLivePlayerTabClick: satelliteDecorator(
        (satellite, playerName) => {
            setWatchLivePlayerName(playerName);
            satellite.track('watch-live-player-tab-click');
        },
    ),
    trackWatchLiveFeaturedHoleClick: satelliteDecorator(
        (satellite, holeName) => {
            setWatchLiveFeaturedHoleName(holeName);
            satellite.track('watch-live-featured-hole-click');
        },
    ),
    trackWatchLiveRightRailTabClick: satelliteDecorator(
        (satellite, watchLiveVideoTab) => {
            setWatchLiveVideoTab(watchLiveVideoTab);
            satellite.track('watch-live-right-rail-tab-click');
        },
    ),
    trackDrawerStatisticsScroll: satelliteDecorator((satellite, pageType) => {
        const drawerStatisticsLocation =
            pageType === PROBABILITY_PAGE_TYPE.LEADERBOARD
                ? 'Leader Board'
                : 'Live Video Drawer';

        setDrawerStatisticsLocation(drawerStatisticsLocation);
        satellite.track('drawer-statistics-scroll');
    }),
    trackPreInfoButtonClick: satelliteDecorator((satellite) => {
        satellite.track('pre-info-button-click');
    }),
    trackRelatedContentCardClick: satelliteDecorator(
        (satellite, relatedContentCardModuleName, relatedContentCardTags) => {
            setRelatedContentCardModuleName(relatedContentCardModuleName);
            setRelatedContentCardTags(relatedContentCardTags);
            satellite.track('related-content-card-click');
        },
    ),
    trackYourClipsVideoLaunches: satelliteDecorator(
        (satellite, yourClipsVideo, playerName, round, hole) => {
            setYourClipsVideo(yourClipsVideo);
            setYourClipsVideoPlayerName(playerName);
            setYourClipsVideoRound(round);
            setYourClipsVideoHole(hole);
            satellite.track('your-clips-video-launches');
        },
    ),
    trackYourClipsVideoNextVideo: satelliteDecorator(
        (satellite, yourClipsVideo, playerName, round, hole) => {
            setYourClipsVideo(yourClipsVideo);
            setYourClipsVideoPlayerName(playerName);
            setYourClipsVideoRound(round);
            setYourClipsVideoHole(hole);
            satellite.track('your-clips-video-next-video');
        },
    ),
    trackMiniPlayerClick: satelliteDecorator(
        (satellite, miniPlayerWatchTime, miniPlayerVideo) => {
            setMiniPlayerWatchTime(miniPlayerWatchTime);
            setMiniPlayerVideo(miniPlayerVideo);
            satellite.track('mini-player-click');
        },
    ),
    trackPlayerComparisonProbabilityChart: satelliteDecorator(
        (satellite, miniPlayerVideo) => {
            setMiniPlayerVideo(miniPlayerVideo);
            satellite.track('player-comparison-probability-chart');
        },
    ),
    trackPreProbabilityClicks: satelliteDecorator(
        (satellite, playerName, tabName, moduleName, compareName) => {
            setProbabilityTabName(tabName);
            setPlayerName(playerName);
            setProbabilityModuleName(moduleName);
            setComparisonPlayerNames(compareName);
            satellite.track('pre-probability-clicks');
        },
    ),
    trackPillModuleLink: satelliteDecorator((satellite, title) => {
        setPillModuleTitle(title);
        let pageType;

        switch (window.globalSettings.pageType) {
            case 'photo-gallery': {
                pageType = 'Photo Gallery';
                break;
            }
            case 'video-features': {
                pageType = 'VOD';
                break;
            }
            case 'article': {
                pageType = 'Article';
                break;
            }
            case 'latest': {
                pageType = 'Latest';
                break;
            }
        }

        setPillPageType(pageType);

        satellite.track('pill-module-link');
    }),
    trackProbabilityChartSlide: satelliteDecorator(
        (satellite, playerName, tabName, pageType) => {
            setPlayerName(playerName);
            setProbabilityTabName(_.startCase(_.camelCase(tabName)));

            const drawerStatisticsLocation =
                pageType === PROBABILITY_PAGE_TYPE.LEADERBOARD
                    ? 'Leader Board Scorecard'
                    : 'Live Video Drawer';

            setProbabilityModuleName(drawerStatisticsLocation);
            satellite.track('probability-chart-slide');
        },
    ),
    trackPickemGameClick: satelliteDecorator((satellite, title) => {
        setPickemGameTitle(title);

        satellite.track('pickem-game-click');
    }),
};

function setVideoLaunchDigitalData(videoName, videoSourceLocation) {
    _.merge(window.digitalData, {
        videoName,
        videoSourceLocation,
    });
}

function setLiveVideoViewDigitalData(selectedMultiviewLiveView) {
    _.merge(window.digitalData, {
        selectedMultiviewLiveOption: selectedMultiviewLiveView,
    });
}

function setRoadToUsoDigitalData(playerName) {
    _.merge(window.digitalData, {
        playerName: playerName,
    });
}

function setTabDigitalData(tab, tabData) {
    window.digitalData = window.digitalData || {};

    window.digitalData[tab] = tabData;
}

function setAmexDigitalData() {
    _.merge(window.digitalData, {
        page: {
            pageInfo: {
                amexAlertLoad: 'true',
            },
        },
    });
}

function setTrandingDigitalData() {
    _.merge(window.digitalData, {
        page: {
            pageInfo: {
                trendingBoxLoads: 'true',
            },
        },
    });
}

function getPageTypeVC() {
    let pageType = 'default';
    switch (window.globalSettings.pageType) {
        case 'photo-gallery': {
            pageType = 'Photo Gallery';
            break;
        }
        case 'video-features': {
            pageType = 'Video Detail';
            break;
        }
        case 'article': {
            pageType = 'Article';
            break;
        }
        case 'latest': {
            pageType = 'Home Page';
            break;
        }
    }

    return pageType;
}

function setPageDigitalDataVC(pageName) {
    if (pageName.indexOf('-') > -1) {
        pageName = pageName.split('-')[0].trim();
    }

    const pageUrl = urlUtil.getPathName().replace(/.html/g, '');
    const prevDigitalData =
        typeof window.digitalData !== 'undefined' ? window.digitalData : {};

    const previousPageName =
        sessionStorage.getItem('adobeAnalyticsDigitalDataPageName') || '';
    const pageInfo = {
        PageName: pageName,
        Platform: 'Website',
        PageUrl: pageUrl,
        PreviousPageName: previousPageName,
        PageType: getPageTypeVC(),
    };
    sessionStorage.setItem('adobeAnalyticsDigitalDataPageName', pageName);

    pageUrl
        .split('/')
        .filter((part) => !!part)
        .slice(-3)
        .forEach(
            (part, index) => (pageInfo['SiteSectionL' + (index + 1)] = part),
        );

    window.digitalData = _.assign(prevDigitalData, {
        page: {
            pageInfo,
        },
    });
}

function setPageDigitalData(pageName) {
    if (pageName.indexOf('-') > -1) {
        pageName = pageName.split('-')[0].trim();
    }

    let pageInfo = {
        PageName: pageName,
        Platform: 'Website',
    };

    sessionStorage.setItem('adobeAnalyticsDigitalDataPageName', pageName);

    urlUtil
        .getPathName()
        .replace(/.html/g, '')
        .split('/')
        .filter((part) => !!part)
        .slice(-3)
        .forEach(
            (part, index) => (pageInfo['SiteSectionL' + (index + 1)] = part),
        );

    if (
        window.digitalData &&
        window.digitalData.page &&
        window.digitalData.page.pageInfo
    ) {
        window.digitalData.page.pageInfo = _.assign(
            window.digitalData.page.pageInfo,
            pageInfo,
        );
    } else {
        window.digitalData = _.assign(window.digitalData || {}, {
            page: {
                pageInfo,
            },
        });
    }
}

function setKbygDigitalData(moduleName) {
    _.merge(window.digitalData, {
        kbygModule: moduleName,
    });
}

function setVideoFilterDigitalData(filterName) {
    _.merge(window.digitalData, {
        vodFilter: filterName,
    });
}

function setScatterPlotDigitalData(element) {
    _.merge(window.digitalData, {
        scatterPlot: element,
    });
}

function setShotsDigitalData(playerId) {
    _.merge(window.digitalData, {
        playerName: playerId,
    });
}

function setLeaderboardFavoritingDigitalData(playerName) {
    _.merge(window.digitalData, {
        playerName,
    });
}

function setLeaderboardExpandDigitalData(playerName) {
    _.merge(window.digitalData, {
        playerName,
    });
}

function setTistoryTimelineCollectionTag(tagName) {
    _.merge(window.digitalData, {
        historyTimelineCollectionTag: tagName,
    });
}

function setTistoryTimelineYear(year) {
    _.merge(window.digitalData, {
        historyTimelineCollectionYear: year,
    });
}

function setTistoryTimelineTag(tag) {
    _.merge(window.digitalData, {
        historyTimelineCollectionTag: tag,
    });
}

function setHistoryContentView(cardTitle, cardType, year, tag) {
    _.merge(window.digitalData, {
        historyTimelineCardTitle: cardTitle,
        historyTimelineCardType: cardType,
        historyTimelineCollectionYear: year,
        historyTimelineCollectionTag: tag,
    });
}

function setHistoryTimelineVideoLauch(videoName, videoLocation) {
    _.merge(window.digitalData, {
        videoName: videoName,
        videoSourceLocation: videoLocation,
    });
}

function setInfoCardTitleExpand(infoCardTitle) {
    _.merge(window.digitalData, {
        infoCardTitle: infoCardTitle,
    });
}

function setTimelinePhotoGalleryName(galleryName) {
    _.merge(window.digitalData, {
        photoCardTitle: galleryName,
    });
}

function setTimelineGalleryPhotoId(photoId) {
    _.merge(window.digitalData, {
        photoId,
    });
}

function setTimelineGalleryPhotoCaption(photoCaption) {
    _.merge(window.digitalData, {
        photoCaption,
    });
}

function setTimelineGalleryPhotoNumber(photoNumber) {
    _.merge(window.digitalData, {
        photoNumber,
    });
}

function setLiveVideoLocation(liveVideoLocation) {
    _.merge(window.digitalData, {
        liveVideoLocation: liveVideoLocation,
    });
}

function setSearchTerms(searchTerms) {
    _.merge(window.digitalData, {
        searchTerms: searchTerms,
    });
}

function setContentItemData(itemNumber, itemType) {
    _.merge(window.digitalData, {
        contentItemNumber: itemNumber,
        contentItemType: itemType,
    });
}

function setPlayerCourseName(name) {
    _.merge(window.digitalData, {
        searchPlayerCourseName: name,
    });
}

function setMixedCardType(cardType) {
    _.merge(window.digitalData, {
        mixedCardType: cardType,
    });
}

function setPlayerName(playerName) {
    _.merge(window.digitalData, {
        playerName,
    });
}

function setProbabilityTabName(probabilityTabName) {
    _.merge(window.digitalData, {
        probabilityTabName,
    });
}

function setLatestCardBadge(latestCardBadge) {
    _.merge(window.digitalData, {
        latestCardBadge,
    });
}

function setAlertMessage(alertMessage) {
    _.merge(window.digitalData, {
        alertMessage,
    });
}

function setAlertType(alertType) {
    _.merge(window.digitalData, {
        alertType,
    });
}

function setComparisonPlayerNames(comparisonPlayerNames) {
    _.merge(window.digitalData, {
        comparisonPlayerNames,
    });
}

function setPlayerComparisonLocation(playerComparisonLocation) {
    _.merge(window.digitalData, {
        playerComparisonLocation,
    });
}

function setTargetUrl(targetUrl) {
    _.merge(window.digitalData, {
        targetUrl,
    });
}

function setTargetTitle(targetTitle) {
    _.merge(window.digitalData, {
        targetTitle,
    });
}

function setMenuItemName(menuItemName) {
    _.merge(window.digitalData, {
        menuItemName,
    });
}

function setMenuItemURL(menuItemURL) {
    _.merge(window.digitalData, {
        menuItemURL,
    });
}

function setWatchLivePlayerName(watchLivePlayerName) {
    _.merge(window.digitalData, {
        watchLivePlayerName,
    });
}

function setWatchLiveFeaturedHoleName(watchLiveFeaturedHoleName) {
    _.merge(window.digitalData, {
        watchLiveFeaturedHoleName,
    });
}

function setProbabilityModuleName(probabilityModuleName) {
    _.merge(window.digitalData, {
        probabilityModuleName,
    });
}

function setProbabilityTracker(probabilityTracker) {
    _.merge(window.digitalData, {
        probabilityTracker,
    });
}

function setSourcePage(sourcePage) {
    _.merge(window.digitalData, {
        sourcePage,
    });
}

function setWatchLiveVideoTab(watchLiveVideoTab) {
    _.merge(window.digitalData, {
        watchLiveVideoTab,
    });
}

function setDrawerStatisticsLocation(drawerStatisticsLocation) {
    _.merge(window.digitalData, {
        drawerStatisticsLocation,
    });
}

function setRelatedContentCardModuleName(relatedContentCardModuleName) {
    _.merge(window.digitalData, {
        relatedContentCardModuleName,
    });
}

function setRelatedContentCardTags(relatedContentCardTags) {
    _.merge(window.digitalData, {
        relatedContentCardTags,
    });
}

function setYourClipsVideo(yourClipsVideo) {
    _.merge(window.digitalData, {
        yourClipsVideo,
    });
}

function setYourClipsVideoHole(yourClipsVideoHole) {
    _.merge(window.digitalData, {
        yourClipsVideoHole,
    });
}

function setYourClipsVideoPlayerName(yourClipsVideoPlayerName) {
    _.merge(window.digitalData, {
        yourClipsVideoPlayerName,
    });
}

function setYourClipsVideoRound(yourClipsVideoRound) {
    _.merge(window.digitalData, {
        yourClipsVideoRound,
    });
}

function setMiniPlayerWatchTime(miniPlayerWatchTime) {
    _.merge(window.digitalData, {
        miniPlayerWatchTime,
    });
}

function setMiniPlayerVideo(miniPlayerVideo) {
    _.merge(window.digitalData, {
        miniPlayerVideo,
    });
}

function setProbabilityPlayerName(probabilityPlayerName) {
    _.merge(window.digitalData, {
        probabilityPlayerName,
    });
}

function setPlayerStatsRound(playerStatsRound) {
    _.merge(window.digitalData, {
        playerStatsRound,
    });
}

function setRoundTracker(round) {
    let roundTracker;
    if (['1', '2', '3', '4'].includes(round)) {
        roundTracker = `Round ${round}`;
    } else if (round === 'all') {
        roundTracker = `All Rounds`;
    }
    if (roundTracker) {
        _.merge(window.digitalData, {
            roundTracker,
        });
    }
}

function setPillModuleTitle(pillModuleTitle) {
    _.merge(window.digitalData, {
        pillModuleTitle,
    });
}

function setPillPageType(pillPageType) {
    _.merge(window.digitalData, {
        pillPageType,
    });
}

function setPickemGameTitle(pickemGameTitle) {
    _.merge(window.digitalData, {
        pickemGameTitle,
    });
}

function setVCPhotoGalleryName(vcPhotoGalleryName) {
    _.merge(window.digitalData, {
        vcPhotoGalleryName,
    });
}

function setVCArticleName(vcArticleName) {
    _.merge(window.digitalData, {
        vcArticleName,
    });
}

function setLatestPinnedCardTitle(vcLatestPinnedCardTitle) {
    _.merge(window.digitalData, {
        vcLatestPinnedCardTitle,
    });
}

function setLatestCardIndex(vcLatestCardIndex) {
    _.merge(window.digitalData, {
        vcLatestCardIndex,
    });
}

function setVCVideoName(vcVideoName) {
    _.merge(window.digitalData, {
        vcVideoName,
    });
}

function setVCHeroSlideImageTitle(vcHeroSlideImageTitle) {
    _.merge(window.digitalData, {
        vcHeroSlideImageTitle,
    });
}

function setVCHeroSlideButtonTitle(vcHeroSlideButtonTitle) {
    _.merge(window.digitalData, {
        vcHeroSlideButtonTitle,
    });
}

function setVCHeroSlideNumber(vcHeroSlideNumber) {
    _.merge(window.digitalData, {
        vcHeroSlideNumber,
    });
}

function setLatestContentFilterChange(vcActiveLatestContentFilter) {
    _.merge(window.digitalData, {
        vcActiveLatestContentFilter,
    });
}
